import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useLoading } from '../context/LoadingContext';

// List of cooking-related terms for the loader text
const loaderTexts = [
  '<Cooking>',
  '<Basting>',
  '<Roasting>',
  '<Steaming>',
  '<Sizzling>',
  '<Grilling>',
  '<Braai\'ing>',
  '<Marinating>',
  '<Seasoning>',
  '<Preparing>'
];

interface LinkInterceptorProps extends LinkProps {
  children: React.ReactNode;
}

const LinkInterceptor: React.FC<LinkInterceptorProps> = ({ children, to, ...rest }) => {
  const { setIsLoading, setLoaderText } = useLoading();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Don't intercept if it's the current page
    if (to === window.location.pathname) {
      return;
    }

    // Select a random loader text
    const randomIndex = Math.floor(Math.random() * loaderTexts.length);
    setLoaderText(loaderTexts[randomIndex]);
    
    // Show loader immediately
    setIsLoading(true);
  };

  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
};

export default LinkInterceptor;